import React from 'react';
import T from 'prop-types';
import { LocalNavigation } from '@acast/decibel';
import { ChartBarRegularGlyph } from '@acast/decibel-glyphs';
import getInsightsUrl from './get-insights-url';

export default function InsightsItem({ showId }) {
  return (
    <LocalNavigation.Item glyph={ChartBarRegularGlyph} href={getInsightsUrl(showId)}>
      View Insights
    </LocalNavigation.Item>
  );
}

InsightsItem.propTypes = {
  showId: T.string,
};

InsightsItem.defaultProps = {
  showId: undefined,
};
